module.exports = __webpack_public_path__ + "static/media/5f8de7ed5ae7590275f07517_banner_800x600.eaf58fe0.png";